import { render, staticRenderFns } from "./display-brand.vue?vue&type=template&id=2e9c431b&scoped=true"
import script from "./display-brand.vue?vue&type=script&lang=js"
export * from "./display-brand.vue?vue&type=script&lang=js"
import style0 from "./display-brand.vue?vue&type=style&index=0&id=2e9c431b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c431b",
  null
  
)

export default component.exports